import { useEffect, useState } from "react";
import { Creator } from "./creator/Creator";
import { FlightScreen } from "./flight/FlightScreen";
import { MatchScreen } from "./match/MatchScreen";
import { MainMenu } from "./menu/MainMenu";
import { screenFromHash, type Screen } from "./routes";
import { StadiumScreen } from "./stadium/StadiumScreen";

/**
 * Telas por endereço: menu (vazio ou `#`, item 4.5), `#partida` (item 4.5), `#voo` (treino livre, itens 4.1 a 4.4),
 * `#criar` (criador, item 2.7) e `#estadio` (item 3.1).
 */
export function App() {
  const [screen, setScreen] = useState<Screen>(() => screenFromHash(location.hash));
  useEffect(() => {
    const onHash = () => setScreen(screenFromHash(location.hash));
    addEventListener("hashchange", onHash);
    return () => removeEventListener("hashchange", onHash);
  }, []);
  if (screen === "estadio") return <StadiumScreen />;
  if (screen === "voo") return <FlightScreen />;
  if (screen === "partida") return <MatchScreen />;
  if (screen === "criador") return <Creator />;
  return <MainMenu />;
}
